import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useTopBarCtx } from '../contexts/TopBarContext.js';
import { useContact } from '../hooks/useContacts.js';
import { ContactDetail } from '../components/contacts/ContactDetail.js';
import { ContactClaudePanel } from '../components/contacts/ContactClaudePanel.js';

/* Detalle de contacto a pantalla completa (V2): la lista de Contactos dejó
 * de ser split-pane — cada contacto tiene su ruta propia, patrón LEADS. */
export function ContactDetailPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();
  const contactId = id ? parseInt(id) : null;
  const { setOverride } = useTopBarCtx();
  const { data: contact } = useContact(contactId);

  useEffect(() => {
    const name = contact
      ? [contact.firstName, contact.lastName].filter(Boolean).join(' ') || contact.businessName || t('contacts.pageTitle')
      : t('contacts.pageTitle');
    setOverride({ title: name });
    return () => setOverride({});
  }, [setOverride, contact, t]);

  if (contactId == null || isNaN(contactId)) {
    navigate('/contacts', { replace: true });
    return null;
  }

  return (
    <div className="flex h-full overflow-hidden animate-fade-blur-in">
      <div className="flex flex-col flex-1 min-w-0 overflow-hidden">
        <ContactDetail
          id={contactId}
          onClose={() => navigate('/contacts')}
          onDeleted={() => navigate('/contacts')}
        />
      </div>
      <ContactClaudePanel contact={contact ?? null} />
    </div>
  );
}
